export enum AppErrorMinor {
  LoadSelectables = 'loadSelectables',
  ChangeSelectable = 'changeSelectable',
  LoadingIssue = 'loadingIssue'
}
